module.exports = __webpack_public_path__ + "img/tethys.982be380.png";